<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          v-if="dialog.form"
          :fullscreen="dialog.fullscreen"
          width="800"
          persistent
          scrollable
          content-class="order-detail-dialog-wrap">
          <v-card
            class="order-detail-dialog"
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title class="order-detail-dialog__header">
              <div class="order-detail-dialog__header-text">
                <p class="order-detail-dialog__eyebrow">Pemakaian / Penggunaan</p>
                <h1 class="order-detail-dialog__title">Detail data</h1>
              </div>

              <div class="order-detail-dialog__head-actions">
                <button
                  type="button"
                  class="order-detail-dialog__icon-btn"
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  :aria-label="!dialog.fullscreen ? 'Perbesar' : 'Kecilkan'"
                  :title="!dialog.fullscreen ? 'Perbesar' : 'Kecilkan'">
                  <v-icon size="18" color="#5B6470">
                    {{ !dialog.fullscreen ? 'mdi-arrow-expand' : 'mdi-arrow-collapse' }}
                  </v-icon>
                </button>

                <button
                  type="button"
                  class="order-detail-dialog__icon-btn"
                  @click="dialog.form = false; dialog.fullscreen = false;"
                  aria-label="Tutup"
                  title="Tutup">
                  <v-icon size="18" color="#5B6470">mdi-close</v-icon>
                </button>
              </div>
            </v-card-title>

            <v-card-text class="order-detail-dialog__body">
              <div v-if="!process.detail && selected.detail.length > 0" class="order-detail">
                <section class="order-detail__summary">
                  <div class="order-detail__summary-left">
                    <h2 class="order-detail__facility">{{ selected.detail[0].product_name }}</h2>
                    <div class="order-detail__summary-meta mb-2">
                      <div class="order-detail__booking d-flex align-center">
                        {{ selected.detail[0].event_start_date | dateFull }}
                        <div class="order-detail__booking-sep">–</div>
                        {{ selected.detail[0].event_end_date | dateFull }}
                      </div>
                    </div>
                    <div
                      class="order-detail__badge"
                      :class="'order-detail__badge--' + String(selected.detail[0].status || '').replace(/\s+/g, '-')">
                      <v-icon size="14" class="order-detail__badge-icon" :color="selected.detail[0].status === 'diterima' ? 'success' : '#0072B2'">mdi-check</v-icon>
                      <div class="font-weight-bold text-capitalize">{{ selected.detail[0].status }}</div>
                    </div>
                    <div
                      class="order-detail__badge"
                      v-if="selected.detail[0].status == 'diterima'"
                      :class="'order-detail__badge--pay-' + String(selected.detail[0].payment_status || '').replace(/\s+/g, '-')">
                      <v-icon size="14" class="order-detail__badge-icon" :color="selected.detail[0].payment_status === 'lunas' ? 'success' : 'warning'">mdi-credit-card-outline</v-icon>
                      <div class="font-weight-bold text-capitalize">{{ selected.detail[0].payment_status }}</div>
                    </div>
                  </div>
                  <div class="order-detail__summary-right">
                    <div class="order-detail__total-label">TOTAL</div>
                    <div class="order-detail__total-value">{{ selected.detail[0].total | price }}</div>
                    <div class="order-detail__billing" v-if="selected.detail[0].status === 'diterima'">
                      Billing {{ selected.detail[0].id_billing || '-' }}
                    </div>
                    <div class="order-detail__billing" v-else>
                      Billing —
                    </div>
                  </div>
                </section>

                <div class="order-detail__tabs" role="tablist">
                  <button
                    type="button"
                    role="tab"
                    class="order-detail__tab"
                    :class="{ 'order-detail__tab--active': detailTab === 'pelanggan' }"
                    :aria-selected="detailTab === 'pelanggan'"
                    @click="detailTab = 'pelanggan'">
                    <v-icon size="15" class="order-detail__tab-icon">mdi-account-outline</v-icon>
                    Pelanggan &amp; Event
                  </button>
                  <button
                    type="button"
                    role="tab"
                    class="order-detail__tab"
                    :class="{ 'order-detail__tab--active': detailTab === 'dokumen' }"
                    :aria-selected="detailTab === 'dokumen'"
                    @click="detailTab = 'dokumen'">
                    <v-icon size="15" class="order-detail__tab-icon">mdi-file-document-outline</v-icon>
                    Pembayaran &amp; Dokumen
                  </button>
                </div>

                <div v-show="detailTab === 'pelanggan'" class="order-detail__panel-tab" role="tabpanel">
                  <div class="order-detail__grid2">
                    <div>
                      <div class="order-detail__field-row">
                        <v-icon size="14" class="order-detail__field-icon">mdi-account-outline</v-icon>
                        <div class="order-detail__field-body">
                          <div class="order-detail__field-label">Nama</div>
                          <div class="order-detail__field-value">{{ selected.detail[0].customer_name }}</div>
                        </div>
                      </div>
                      <div class="order-detail__field-row">
                        <v-icon size="14" class="order-detail__field-icon">mdi-phone-outline</v-icon>
                        <div class="order-detail__field-body">
                          <div class="order-detail__field-label">Telepon</div>
                          <div class="order-detail__field-value order-detail__mono">{{ selected.detail[0].customer_mobilephone }}</div>
                        </div>
                      </div>
                      <div class="order-detail__field-row">
                        <v-icon size="14" class="order-detail__field-icon">mdi-email-outline</v-icon>
                        <div class="order-detail__field-body">
                          <div class="order-detail__field-label">Email</div>
                          <div class="order-detail__field-value">{{ selected.detail[0].customer_email }}</div>
                        </div>
                      </div>
                      <div class="order-detail__field-row">
                        <v-icon size="14" class="order-detail__field-icon">mdi-map-marker-outline</v-icon>
                        <div class="order-detail__field-body">
                          <div class="order-detail__field-label">Alamat</div>
                          <div class="order-detail__field-value">{{ selected.detail[0].customer_address }}</div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="order-detail__field-row">
                        <v-icon size="14" class="order-detail__field-icon">mdi-calendar</v-icon>
                        <div class="order-detail__field-body">
                          <div class="order-detail__field-label">Nama event</div>
                          <div class="order-detail__field-value">{{ selected.detail[0].so_event_name }}</div>
                        </div>
                      </div>
                      <div class="order-detail__field-row">
                        <v-icon size="14" class="order-detail__field-icon">mdi-tag-outline</v-icon>
                        <div class="order-detail__field-body">
                          <div class="order-detail__field-label">Kategori</div>
                          <div class="order-detail__field-value">{{ selected.detail[0].event_name }}</div>
                        </div>
                      </div>
                      <div class="order-detail__field-row">
                        <v-icon size="14" class="order-detail__field-icon">mdi-message-outline</v-icon>
                        <div class="order-detail__field-body">
                          <div class="order-detail__field-label">Deskripsi</div>
                          <div class="order-detail__field-value">{{ selected.detail[0].event_description }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <section class="order-detail__section order-detail__nominal">
                    <div class="order-detail__section-label">Detail nominal</div>
                    <div>
                      <div
                        v-for="(item, index) in selected.detail[0].so_detail"
                        :key="index"
                        class="order-detail__nominal-row"
                        :class="index > 0 ? 'order-detail__nominal-row--divided' : ''">
                        <div class="d-flex justify-space-between align-center">
                          <div class="order-detail__nominal-date">
                            {{ item.date | dateFull }}
                          </div>
                          <div class="order-detail__nominal-price">
                            {{ item.price_value | price }}
                          </div>
                        </div>
                        <div
                          v-if="item.fasilitas_array && item.fasilitas_array.length > 0"
                          class="order-detail__fasilitas">
                          <div
                            v-for="(fasilitas, idx) in item.fasilitas_array"
                            :key="idx"
                            class="order-detail__fasilitas-item">
                            <div class="d-flex justify-space-between align-center">
                              <div class="order-detail__fasilitas-name">
                                {{ fasilitas.product_facility_name }}
                                <span class="order-detail__fasilitas-qty">({{ fasilitas.qty }}x)</span>
                              </div>
                              <div class="order-detail__fasilitas-price">
                                {{ (parseInt(fasilitas.price) * parseInt(fasilitas.qty)) | price }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="order-detail__nominal-total">
                      <div>Total</div>
                      <div>{{ selected.detail[0].total | price }}</div>
                    </div>
                  </section>

                  <div class="order-detail__attachments">
                    <section class="order-detail__attach">
                      <div class="order-detail__section-label">Photo KTP</div>
                      <div class="order-detail__media">
                        <v-img
                          contain
                          :src="getCdnDisplayUrl(selected.detail[0].nik_url)"
                          :alt="selected.detail[0].product_name"
                          :height="250"
                          width="100%">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular
                                size="20"
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>
                    </section>

                    <section
                      class="order-detail__attach"
                      v-if="selected.detail[0].proposal_url !== ''">
                      <div class="order-detail__section-label">File proposal / permohonan</div>
                      <div class="order-detail__media">
                        <v-img
                          v-if="selected.detail[0].proposal_url.split('.').pop() !== 'pdf'"
                          contain
                          :src="getCdnDisplayUrl(selected.detail[0].proposal_url)"
                          :alt="selected.detail[0].product_name"
                          :height="250"
                          width="100%">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular
                                size="20"
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <div v-if="selected.detail[0].proposal_url.split('.').pop() === 'pdf'">
                          <iframe
                            :src="getCdnDisplayUrl(selected.detail[0].proposal_url)"
                            height="250"
                            width="100%"
                            frameborder="0">
                          </iframe>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>

                <div v-show="detailTab === 'dokumen'" class="order-detail__panel-tab" role="tabpanel">
                  <div class="order-detail__grid2 order-detail__grid2--pay">
                    <div>
                      <div class="order-detail__field-label">Id billing</div>
                      <div class="order-detail__field-value order-detail__mono">
                        {{ selected.detail[0].status === 'diterima' ? selected.detail[0].id_billing : '-' }}
                      </div>
                      <div class="order-detail__field-label">Tanggal pembayaran</div>
                      <div class="order-detail__field-value">
                        <span v-if="selected.detail[0].payment_datetime">
                          {{ selected.detail[0].payment_datetime | datetime }}
                        </span>
                        <span v-else>—</span>
                      </div>
                    </div>
                    <div>
                      <div class="order-detail__field-label">Status pembayaran</div>
                      <div class="order-detail__field-value text-capitalize">{{ selected.detail[0].payment_status }}</div>
                      <div class="order-detail__field-label">Link publik</div>
                      <a
                        :href="`https://sifasum.klaten.go.id//order/${selected.detail[0].uuid}`"
                        target="_blank"
                        class="order-detail__link-row">
                        Buka detail publik
                        <v-icon size="13">mdi-open-in-new</v-icon>
                      </a>
                    </div>
                  </div>

                  <div
                    v-if="selected.detail[0].status === 'diterima'"
                    class="order-detail__docs">
                    <div class="order-detail__section-label">Dokumen</div>

                    <div
                      v-if="selected.detail[0].id_billing !== ''"
                      class="order-detail__doc-group">
                      <div class="order-detail__doc-info">
                        <v-icon size="18" color="#8A929C">mdi-file-document-outline</v-icon>
                        <div>
                          <div class="order-detail__doc-name">STS</div>
                          <div class="order-detail__doc-sub">Surat Tanda Setoran</div>
                          <div>
                            No. STS: {{ selected.detail[0].sts_number || '-' }}
                          </div>
                          <div class="order-detail__doc-meta">
                            Status: <span class="text-capitalize">{{ selected.detail[0].sts_status || '-' }}</span>
                            <span class="order-detail__doc-sep">·</span>
                            Tgl: <span v-if="selected.detail[0].sts_date">{{ selected.detail[0].sts_date | date }}</span><span v-else>-</span>
                            <span class="order-detail__doc-sep">·</span>
                            TTE: <span v-if="selected.detail[0].sts_signed_date">{{ selected.detail[0].sts_signed_date | date }}</span><span v-else>-</span>
                          </div>
                          <a
                            v-if="selected.detail[0].sts_signed_url"
                            href="javascript:;"
                            class="order-detail__link-row order-detail__link-row--sm"
                            @click.prevent="openPdfPreview(selected.detail[0].sts_signed_url, 'Dokumen STS TTE')">
                            Lihat PDF TTE
                            <v-icon size="13">mdi-file-pdf-box</v-icon>
                          </a>
                        </div>
                      </div>
                      <div class="order-detail__doc-actions">
                        <v-btn
                          small
                          :loading="process.export"
                          :disabled="process.export"
                          @click="exports(selected.detail[0].id)"
                          elevation="0"
                          class="order-detail__btn order-detail__btn--download body-2 font-weight-bold text-capitalize">
                          <v-icon size="13" class="mr-1">mdi-download</v-icon>
                          Download
                        </v-btn>
                        <!-- <v-btn
                          v-if="canManageOrder"
                          small
                          :loading="process.esign_sts"
                          :disabled="process.esign_sts || process.esign_stts"
                          @click="openEsignDialog('sts')"
                          elevation="0"
                          class="order-detail__btn order-detail__btn--sign body-2 font-weight-bold text-capitalize">
                          <v-icon size="13" class="mr-1">mdi-draw</v-icon>
                          TTE
                        </v-btn> -->
                      </div>
                    </div>

                    <div
                      v-if="selected.detail[0].payment_status === 'lunas'"
                      class="order-detail__doc-group">
                      <div class="order-detail__doc-info">
                        <v-icon size="18" color="#8A929C">mdi-file-document-outline</v-icon>
                        <div>
                          <div class="order-detail__doc-name">STTS</div>
                          <div class="order-detail__doc-sub">Surat Tanda Terima Setoran</div>
                          <div>
                            No. STTS: {{ selected.detail[0].stts_number || '-' }}
                          </div>
                          <div class="order-detail__doc-meta">
                            Status: <span class="text-capitalize">{{ selected.detail[0].stts_status || '-' }}</span>
                            <span class="order-detail__doc-sep">·</span>
                            Tgl: <span v-if="selected.detail[0].stts_date">{{ selected.detail[0].stts_date | date }}</span><span v-else>-</span>
                            <span class="order-detail__doc-sep">·</span>
                            TTE: <span v-if="selected.detail[0].stts_signed_date">{{ selected.detail[0].stts_signed_date | date }}</span><span v-else>-</span>
                          </div>
                          <a
                            v-if="selected.detail[0].stts_signed_url"
                            href="javascript:;"
                            class="order-detail__link-row order-detail__link-row--sm"
                            @click.prevent="openPdfPreview(selected.detail[0].stts_signed_url, 'Dokumen STTS TTE')">
                            Lihat PDF TTE
                            <v-icon size="13">mdi-file-pdf-box</v-icon>
                          </a>
                        </div>
                      </div>
                      <div class="order-detail__doc-actions">
                        <v-btn
                          small
                          :loading="process.export_stts"
                          :disabled="process.export_stts"
                          @click="exportsStts(selected.detail[0].id)"
                          elevation="0"
                          class="order-detail__btn order-detail__btn--download body-2 font-weight-bold text-capitalize">
                          <v-icon size="13" class="mr-1">mdi-download</v-icon>
                          Download
                        </v-btn>
                        <!-- <v-btn
                          v-if="canManageOrder"
                          small
                          :loading="process.esign_stts"
                          :disabled="process.esign_stts || process.esign_sts"
                          @click="openEsignDialog('stts')"
                          elevation="0"
                          class="order-detail__btn order-detail__btn--sign body-2 font-weight-bold text-capitalize">
                          <v-icon size="13" class="mr-1">mdi-draw</v-icon>
                          TTE
                        </v-btn> -->
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="qr_code !== '' && selected.detail[0].id_billing !== '' && selected.detail[0].status === 'diterima' && selected.detail[0].payment_status === 'belum lunas'"
                    class="order-detail__qr">
                    <div class="order-detail__section-label">QR Code pembayaran</div>
                    <div class="order-detail__qr-card">
                      <div class="order-detail__qr-banner">
                        <img
                          src="https://cdn-1.klaten.go.id/sifasum/image/20250826211158-1756242718.jpg"
                          alt="QRIS Header"
                        />
                      </div>
                      <div class="order-detail__qr-code">
                        <img
                          :src="qr_code"
                          alt="QRIS Code"
                        />
                      </div>
                      <div class="order-detail__qr-info">
                        <div class="order-detail__qr-name">{{ selected.detail[0].customer_name || 'Customer Name' }}</div>
                        <div class="order-detail__qr-amount">{{ selected.detail[0].total | price }}</div>
                      </div>
                      <a
                        :href="qr_code"
                        target="_blank"
                        class="order-detail__qr-download text-decoration-none"
                        :style="{ backgroundColor: set_color }">
                        <v-icon class="mr-2" color="white" size="18">mdi-download</v-icon>
                        <span>Download</span>
                      </a>
                    </div>
                  </div>

                  <div v-if="process.create_qr" class="order-detail__qr-loading">
                    Memuat QR Code . . .
                  </div>

                  <div
                    v-if="selected.detail[0].upgrade_from_so_id !== undefined && selected.detail[0].upgrade_from_so_id !== null && selected.detail[0].upgrade_from_so_id !== '' && selected.detail[0].upgrade_from_so_id !== '0' && selected.detail[0].upgrade_from_so_id !== 0"
                    class="order-detail__upgrade">
                    <v-icon color="#8a5a12" class="mr-3" style="margin-top: 1px;">mdi-call-split</v-icon>
                    <div>
                      <div class="order-detail__upgrade-title">
                        Data ini upgrade dari order sebelumnya
                      </div>
                      <div v-if="selected.upgrade_from_detail" class="order-detail__upgrade-meta">
                        Invoice <b>{{ selected.upgrade_from_detail.id_billing || '-' }}</b>
                        <span class="mx-1">·</span>
                        Total <b>{{ selected.upgrade_from_detail.total | price }}</b>
                      </div>
                      <div v-else class="order-detail__upgrade-meta">
                        Memuat data order asal...
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="process.detail" class="order-detail__loading">
                <div class="order-detail__loading-inner">
                  <div class="order-detail__loading-title">Mohon tunggu</div>
                  <div class="order-detail__loading-sub">Menyiapkan detail pemakaian</div>
                  <v-progress-linear
                    class="mt-4"
                    :color="set_color"
                    indeterminate
                    rounded
                    height="4">
                  </v-progress-linear>
                </div>
              </div>
            </v-card-text>

            <v-card-actions class="order-detail-dialog__footer">
              <div class="order-detail-dialog__foot-left">
                <v-btn
                  v-if="canManageOrder"
                  @click="dialog.update = true;"
                  elevation="0"
                  class="order-detail__footer-btn order-detail__footer-btn--primary body-2 font-weight-bold text-capitalize">
                  Ubah Data
                </v-btn>
                <v-btn
                  v-if="canManageOrder && selected.detail[0].payment_status === 'lunas'"
                  @click="dialog.upgrade = true"
                  elevation="0"
                  class="order-detail__footer-btn order-detail__footer-btn--upgrade body-2 font-weight-bold text-capitalize">
                  Upgrade
                </v-btn>
                <v-btn
                  v-if="canManageOrder && (selected.detail[0].status === 'dalam proses' || selected.detail[0].status === 'ditolak')"
                  @click="dialog.approval = true; process.approval = false; selected.approval[0] = { status: 'diterima', description: '' }"
                  elevation="0"
                  class="order-detail__footer-btn order-detail__footer-btn--accept body-2 font-weight-bold text-capitalize">
                  Terima
                </v-btn>
                <v-btn
                  v-if="canManageOrder && selected.detail[0].status === 'dalam proses'"
                  @click="dialog.approval = true; process.approval = false; selected.approval[0] = { status: 'ditolak', description: '' };"
                  elevation="0"
                  class="order-detail__footer-btn order-detail__footer-btn--reject body-2 font-weight-bold text-capitalize">
                  Tolak
                </v-btn>
              </div>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                elevation="0"
                class="order-detail__footer-btn order-detail__footer-btn--close body-2 font-weight-bold text-capitalize">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.approval"
          @keydown.esc="dialog.approval = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          v-if="dialog.approval"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Konfirmasi {{ selected.approval[0].status === 'diterima' ? 'Diterima' : 'Ditolak' }}

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.approval = false; dialog.fullscreen = false; selected.approval = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin untuk {{ selected.approval[0].status === 'diterima' ? 'menerima' : 'menolak' }} data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?

              <div class="mt-5">
                <v-textarea
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Deskripsi"

                  hide-details

                  v-model="selected.approval[0].description"
                  style="border-radius: 10px;">
                </v-textarea>
              </div>
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="approvals()"
                :loading="process.approval"
                :disabled="process.approval"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Yakin
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.approval = false; dialog.fullscreen = false; selected.approval = [];"
                :disabled="process.approval"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.esign"
          @keydown.esc="closeEsignDialog()"
          width="500"
          persistent
          scrollable>
          <v-card class="border-radius">
            <v-card-title class="d-flex align-center pa-4 text-right popup-header">
              <div class="title font-weight-bold">
                TTE {{ esign.type === 'stts' ? 'STTS' : 'STS' }}
              </div>

              <v-spacer/>

              <v-icon
                @click="closeEsignDialog()"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>

            <v-divider
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text class="pt-4">
              <form autocomplete="off" @submit.prevent="esignOrderPdf()">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Passphrase
                </div>
                <v-text-field
                  v-model="esign.passphrase"
                  name="bsre_passphrase"
                  autocomplete="new-password"
                  outlined
                  dense
                  :color="set_color"
                  placeholder="Passphrase sertifikat BSrE"
                  hide-details
                  type="password"
                  spellcheck="false"
                  autocapitalize="off"
                  autocorrect="off"
                  class="mb-2 rounded-lg"
                  :disabled="esignProcessing">
                </v-text-field>
              </form>
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-2">
              <div class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                <span class="ml-1">{{ message.error }}</span>
              </div>
            </div>

            <v-divider
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="140"
                @click="esignOrderPdf()"
                :loading="esignProcessing"
                :disabled="esignProcessing"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text text-capitalize">
                Tanda tangan
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="closeEsignDialog()"
                :disabled="esignProcessing"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.esignResult"
          @keydown.esc="closeEsignResultDialog()"
          width="420"
          persistent>
          <v-card class="border-radius esign-result">
            <v-icon
              @click="closeEsignResultDialog()"
              class="esign-result__close"
              size="20"
              color="grey darken-1">
              mdi-close
            </v-icon>

            <v-card-text class="esign-result__body">
              <v-avatar
                size="64"
                class="esign-result__icon-wrap"
                :class="esign.result === 'success' ? 'esign-result__icon-wrap--success' : 'esign-result__icon-wrap--error'">
                <v-icon
                  size="34"
                  :color="esign.result === 'success' ? '#2f9e5b' : '#d9534f'">
                  {{ esign.result === 'success' ? 'mdi-check' : 'mdi-close' }}
                </v-icon>
              </v-avatar>

              <div class="esign-result__title">
                {{ esign.result === 'success' ? 'Berhasil!' : 'Gagal!' }}
              </div>

              <div class="esign-result__message">
                {{ esign.resultMessage }}
              </div>
            </v-card-text>

            <v-card-actions class="esign-result__actions">
              <v-btn
                rounded
                width="160"
                @click="closeEsignResultDialog()"
                :color="esign.result === 'success' ? '#3355a8' : '#d9534f'"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialog.pdfPreview"
          @keydown.esc="closePdfPreview()"
          width="900"
          scrollable
          content-class="pdf-preview-dialog">
          <v-card class="border-radius pdf-preview">
            <v-card-title class="d-flex align-center pa-4 text-right popup-header">
              <div class="title font-weight-bold">
                {{ pdfPreview.title || 'Preview PDF' }}
              </div>

              <v-spacer/>

              <v-icon
                @click="closePdfPreview()"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>

            <v-divider
              class="mb-0"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text class="pa-0 pdf-preview__body">
              <iframe
                v-if="pdfPreview.url"
                :src="pdfPreview.url"
                class="pdf-preview__frame"
                frameborder="0"
                title="Preview PDF">
              </iframe>
            </v-card-text>

            <v-divider
              class="mt-0"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                @click="openPdfPreviewInNewTab()"
                color="primary"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text pr-3">
                <v-icon size="16" left>mdi-open-in-new</v-icon>
                Open New Tab
              </v-btn>

              <v-btn
                rounded
                @click="downloadPdfPreview()"
                :loading="process.pdf_download"
                :disabled="process.pdf_download"
                color="#097640"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text pr-3">
                <v-icon size="16" left>mdi-download</v-icon>
                Download
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="closePdfPreview()"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div v-if="dialog.update">
          <UpdatOrder
            :products="product"
            :dialog="dialog.update"
            :order="selected.detail[0]"
            @close="dialog.update = false;" 
            @update="fetch(); fetchDetailOrder(selected.detail[0].id)" />
        </div>

        <div v-if="dialog.upgrade">
          <UpgradeOrder
            :products="product"
            :dialog="dialog.upgrade"
            :order="selected.detail[0]"
            @close="dialog.upgrade = false"
            @saved="dialog.upgrade = false; fetch(); fetchDetailOrder(selected.detail[0].id)" />
        </div>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <v-row>
                <!-- Filter tanggal: pilih salah satu -->
                <v-col cols="12 pt-0">
                  <div class="body-2 mb-2 black--text font-weight-medium">Filter Tanggal (pilih salah satu)</div>
                  <v-radio-group
                    v-model="dateFilterType"
                    row
                    dense
                    class="mt-0"
                    hide-details
                    @change="onDateFilterTypeChange">
                    <v-radio label="Tgl Input" value="input" :color="set_color"></v-radio>
                    <v-radio label="Tgl Booking" value="booking" :color="set_color"></v-radio>
                    <v-radio label="Tgl Pembayaran" value="payment" :color="set_color"></v-radio>
                  </v-radio-group>
                </v-col>

                <!-- Tanggal Input -->
                <v-col v-if="dateFilterType === 'input'" cols="12" md="12">
                  <!-- <div class="body-2 mb-2 black--text font-weight-medium">Tanggal Input</div> -->
                  <div class="d-flex align-center">
                    <v-menu
                      v-model="menu.input_datetime_gte"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filter.input_datetime_gte"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          filled
                          rounded
                          dense
                          hide-details
                          :color="set_color"
                          placeholder="Dari Tanggal"
                          class="fs-12"
                          style="border-radius: 6px;">
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.input_datetime_gte"
                        @input="menu.input_datetime_gte = false"
                        :max="new Date().toISOString().substr(0, 10)"
                        :color="set_color"
                        locale="id">
                      </v-date-picker>
                    </v-menu>
                    <span class="mx-2">-</span>
                    <v-menu
                      v-model="menu.input_datetime_lte"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filter.input_datetime_lte"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          filled
                          rounded
                          dense
                          hide-details
                          :color="set_color"
                          placeholder="Sampai Tanggal"
                          class="fs-12"
                          style="border-radius: 6px;">
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.input_datetime_lte"
                        @input="menu.input_datetime_lte = false"
                        :min="filter.input_datetime_gte"
                        :max="new Date().toISOString().substr(0, 10)"
                        :color="set_color"
                        locale="id">
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>

                <!-- Tanggal Booking -->
                <v-col v-if="dateFilterType === 'booking'" cols="12" md="12">
                  <!-- <div class="body-2 mb-2 black--text font-weight-medium">Tanggal Booking</div> -->
                  <div class="d-flex align-center">
                    <v-menu
                      v-model="menu.event_start_date"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filter.event_start_date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          filled
                          rounded
                          dense
                          hide-details
                          :color="set_color"
                          placeholder="Dari Tanggal"
                          class="fs-12"
                          style="border-radius: 6px;">
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.event_start_date"
                        @input="menu.event_start_date = false"
                        :color="set_color"
                        locale="id">
                      </v-date-picker>
                    </v-menu>
                    <span class="mx-2">-</span>
                    <v-menu
                      v-model="menu.event_end_date"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filter.event_end_date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          filled
                          rounded
                          dense
                          hide-details
                          :color="set_color"
                          placeholder="Sampai Tanggal"
                          class="fs-12"
                          style="border-radius: 6px;">
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.event_end_date"
                        @input="menu.event_end_date = false"
                        :min="filter.event_start_date"
                        :color="set_color"
                        locale="id">
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>

                <!-- Tanggal Pembayaran -->
                <v-col v-if="dateFilterType === 'payment'" cols="12" md="12">
                  <!-- <div class="body-2 mb-2 black--text font-weight-medium">Tanggal Pembayaran</div> -->
                  <div class="d-flex align-center">
                    <v-menu
                      v-model="menu.payment_datetime_gte"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filter.payment_datetime_gte"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          filled
                          rounded
                          dense
                          hide-details
                          :color="set_color"
                          placeholder="Dari Tanggal"
                          class="fs-12"
                          style="border-radius: 6px;">
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.payment_datetime_gte"
                        @input="menu.payment_datetime_gte = false"
                        :max="new Date().toISOString().substr(0, 10)"
                        :color="set_color"
                        locale="id">
                      </v-date-picker>
                    </v-menu>
                    <span class="mx-2">-</span>
                    <v-menu
                      v-model="menu.payment_datetime_lte"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filter.payment_datetime_lte"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          filled
                          rounded
                          dense
                          hide-details
                          :color="set_color"
                          placeholder="Sampai Tanggal"
                          class="fs-12"
                          style="border-radius: 6px;">
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.payment_datetime_lte"
                        @input="menu.payment_datetime_lte = false"
                        :min="filter.payment_datetime_gte"
                        :max="new Date().toISOString().substr(0, 10)"
                        :color="set_color"
                        locale="id">
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>

                <!-- Nama Fasilitas Umum -->
                <v-col cols="12" md="12">
                  <div class="body-2 mb-2 black--text font-weight-medium">Nama Fasilitas Umum</div>
                  <v-autocomplete
                    v-model="filter.product_id"
                    :items="product"
                    item-text="name"
                    item-value="id"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Pilih Fasilitas Umum"
                    clearable
                    class="fs-12"
                    style="border-radius: 6px;">
                  </v-autocomplete>
                </v-col>

                <!-- Nama Pelanggan -->
                <v-col cols="12" md="12">
                  <div class="body-2 mb-2 black--text font-weight-medium">Nama Pelanggan</div>
                  <v-text-field
                    v-model="filter.customer_name"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Nama Pelanggan"
                    class="fs-12"
                    style="border-radius: 6px;">
                  </v-text-field>
                </v-col>

                <!-- Telepon Pelanggan -->
                <v-col cols="12" md="12">
                  <div class="body-2 mb-2 black--text font-weight-medium">Telepon Pelanggan</div>
                  <v-text-field
                    v-model="filter.customer_mobilephone"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Telepon Pelanggan"
                    class="fs-12"
                    style="border-radius: 6px;">
                  </v-text-field>
                </v-col>

                <!-- Email Pelanggan -->
                <v-col cols="12" md="12">
                  <div class="body-2 mb-2 black--text font-weight-medium">Email Pelanggan</div>
                  <v-text-field
                    v-model="filter.customer_email"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Email Pelanggan"
                    class="fs-12"
                    style="border-radius: 6px;">
                  </v-text-field>
                </v-col>

                <!-- Nama Event -->
                <v-col cols="12" md="12">
                  <div class="body-2 mb-2 black--text font-weight-medium">Nama Event</div>
                  <v-text-field
                    v-model="filter.event_name"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Nama Event"
                    class="fs-12"
                    style="border-radius: 6px;">
                  </v-text-field>
                </v-col>

                <!-- Total Pembayaran -->
                <v-col cols="12" md="12">
                  <div class="body-2 mb-2 black--text font-weight-medium">Total Pembayaran</div>
                  <v-text-field
                    v-model="filter.total"
                    type="number"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Total Pembayaran"
                    class="fs-12"
                    style="border-radius: 6px;">
                  </v-text-field>
                </v-col>

                <!-- Status -->
                <!-- <v-col cols="12" md="12">
                  <div class="body-2 mb-2 black--text font-weight-medium">Status</div>
                  <v-autocomplete
                    v-model="filter.status"
                    :items="status"
                    item-text="text"
                    item-value="value"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Pilih Status"
                    clearable
                    class="fs-12"
                    style="border-radius: 6px;">
                  </v-autocomplete>
                </v-col> -->

                <!-- Status Pembayaran -->
                <v-col cols="12" md="12">
                  <div class="body-2 mb-2 black--text font-weight-medium">Status Pembayaran</div>
                  <v-autocomplete
                    v-model="filter.status_payment"
                    :items="[
                      { id: 'lunas', name: 'Lunas' },
                      { id: 'belum_lunas', name: 'Belum Lunas' }
                    ]"
                    item-text="name"
                    item-value="id"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Pilih Status Pembayaran"
                    clearable
                    class="fs-12"
                    style="border-radius: 6px;">
                  </v-autocomplete>
                </v-col>

                <!-- Status STS -->
                <v-col cols="12" md="6">
                  <div class="body-2 mb-2 black--text font-weight-medium">Status STS</div>
                  <v-autocomplete
                    v-model="filter.sts_status"
                    :items="esignStatusOptions"
                    item-text="text"
                    item-value="value"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Pilih Status STS"
                    clearable
                    class="fs-12"
                    style="border-radius: 6px;">
                  </v-autocomplete>
                </v-col>

                <!-- Status STTS -->
                <v-col cols="12" md="6">
                  <div class="body-2 mb-2 black--text font-weight-medium">Status STTS</div>
                  <v-autocomplete
                    v-model="filter.stts_status"
                    :items="esignStatusOptions"
                    item-text="text"
                    item-value="value"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Pilih Status STTS"
                    clearable
                    class="fs-12"
                    style="border-radius: 6px;">
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-btn
                rounded
                width="120"
                @click="resetFilter()"
                elevation="0"
                outlined
                color="red"
                class="body-2 font-weight-bold text-capitalize">
                Reset
              </v-btn>

              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="dialog.filter = false; dialog.fullscreen = false;"
                elevation="0"
                outlined
                color="grey"
                class="body-2 font-weight-bold text-capitalize">
                Batal
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="applyFilter()"
                elevation="0"
                color="green"
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        
        <section>
          <v-row
            class="pa-4 pb-0 pt-0">
            <v-col
              cols="12" class="pb-1">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="22">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="fs-16 black--text ml-2"
                      style="font-weight: 600;">
                      Daftar Pemakaian / Penggunaan
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="start"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="12"
              class="d-flex align-center pb-1">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                class="fs-12 little-placeholder"
                style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
              </v-text-field>
              <!-- <div class="ml-2">
                <v-text-field
                  @click:clear="filter.date = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line
                  type="date"

                  hide-details
                  :color="set_color"
                  placeholder="Cari Tanggal"
                  clearable

                  v-model="filter.date"
                  class="fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 200px">
                </v-text-field>
              </div> -->
              <div class="ml-2">
                <v-autocomplete
                  @click:clear="clearStatusFilter"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line
                  :items="status"
                  item-text="text"
                  item-value="value"
                  v-on:change="onStatusFilterChange"

                  hide-details
                  :color="set_color"
                  placeholder="Pilih Status"
                  :clearable="!isKadis"
                  :disabled="isKadis"
                  :readonly="isKadis"

                  v-model="filter.status"
                  class="fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 200px">
                </v-autocomplete>
              </div>
              <!-- <div class="ml-2">
                <v-autocomplete
                  @click:clear="filter.product_id = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line
                  :items="product"
                  item-text="name"
                  item-value="id"
                  v-on:change="fetch()"

                  hide-details
                  :color="set_color"
                  placeholder="Pilih Fasilitas Umum"
                  clearable

                  v-model="filter.product_id"
                  class="fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 200px">
                </v-autocomplete>
              </div> -->
              <!-- <div class="ml-2">
                <v-autocomplete
                  @click:clear="filter.status_payment = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line
                  :items="[
                    { id: 'lunas', name: 'Lunas' },
                    { id: 'belum_lunas', name: 'Belum Lunas' }
                  ]"
                  item-text="name"
                  item-value="id"
                  v-on:change="fetch()"

                  hide-details
                  :color="set_color"
                  placeholder="Pilih Status Pembayaran"
                  clearable

                  v-model="filter.status_payment"
                  class="fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 200px">
                </v-autocomplete>
              </div> -->
              <div class="ml-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="dialog.filter = true"
                      elevation="0"
                      dark
                      min-height="28"
                      small
                      min-width="28"
                      :color="set_color"
                      class="text-capitalize px-0 white--text"
                      style="border-radius: 6px; position: relative;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="18">mdi-filter</v-icon>
                      <v-badge
                        v-if="activeFiltersCount > 0"
                        :content="activeFiltersCount"
                        color="red"
                        overlap
                        style="position: absolute; top: -5px; right: -5px;">
                      </v-badge>
                    </v-btn>
                  </template>
                  <span>Filter</span>
                </v-tooltip>
              </div>
              <div class="ml-auto pr-3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="exports_excel()"
                      :loading="process.export_excel"
                      elevation="0"
                      dark
                      min-height="28"
                      small
                      min-width="28"
                      color="#097640"
                      class="text-capitalize px-0 white--text"
                      style="border-radius: 6px;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="18">mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Export Excel</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>

          <!-- Active Filters -->
          <v-row
            v-if="activeFilters.length > 0"
            class="pa-4 pt-2 pb-2">
            <v-col 
              cols="12"
              class="py-0">
              <div class="d-flex align-center flex-wrap">
                <span class="body-2 mr-2 black--text font-weight-medium">Filter Aktif:</span>
                <v-chip
                  v-for="(filterItem, index) in activeFilters"
                  :key="index"
                  small
                  close
                  @click:close="clearFilter(filterItem.key)"
                  :color="set_color"
                  text-color="white"
                  class="mr-2 mb-1"
                  style="height: 24px;">
                  {{ filterItem.label }}: {{ filterItem.value }}
                </v-chip>
                <v-btn
                  small
                  text
                  @click="clearAllFilters()"
                  class="body-2 text-capitalize red--text px-2"
                  style="min-width: auto; height: 24px;">
                  Clear All
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 py-0">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <div class="view">
                  <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper-pegawai'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th :style="`background-color: ${set_color}; color: #fff;`" class="sticky-col one-col" style="z-index: 1;  color: white; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'input_datetime' ? toSort('input_datetime') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Tanggal Input
                          <span v-if="sortBy === 'input_datetime'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Batas Waktu Verifikasi
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Deadline Pembayaran
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'event_start_date' ? toSort('event_start_date') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Tanggal Booking
                          <span v-if="sortBy === 'event_start_date'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'product_name' ? toSort('product_name') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Nama Fasilitas Umum
                          <span v-if="sortBy === 'product_name'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'event_name' ? toSort('event_name') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Kategori Event
                          <span v-if="sortBy === 'event_name'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'so_event_name' ? toSort('so_event_name') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Nama Event
                          <span v-if="sortBy === 'so_event_name'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'customer_name' ? toSort('customer_name') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Nama Pelanggan
                          <span v-if="sortBy === 'customer_name'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'customer_mobilephone' ? toSort('customer_mobilephone') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Telepon Pelanggan
                          <span v-if="sortBy === 'customer_mobilephone'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'customer_email' ? toSort('customer_email') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Email Pelanggan
                          <span v-if="sortBy === 'customer_email'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          ID Billing
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'total' ? toSort('total') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Total Pembayaran
                          <span v-if="sortBy === 'total'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'status' ? toSort('status') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Status
                          <span v-if="sortBy === 'status'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'payment_status' ? toSort('payment_status') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Status Pembayaran
                          <span v-if="sortBy === 'payment_status'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'payment_datetime' ? toSort('payment_datetime') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Tanggal Pembayaran
                          <span v-if="sortBy === 'payment_datetime'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'sts_status' ? toSort('sts_status') : toDesc();" style=" width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Status STS
                          <span v-if="sortBy === 'sts_status'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'sts_date' ? toSort('sts_date') : toDesc();" style=" width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Tanggal STS
                          <span v-if="sortBy === 'sts_date'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" style=" width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          No. STS
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" style=" width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Dokumen STS TTE
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'sts_signed_date' ? toSort('sts_signed_date') : toDesc();" style=" width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Tanggal TTE STS
                          <span v-if="sortBy === 'sts_signed_date'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'stts_status' ? toSort('stts_status') : toDesc();" style=" width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Status STTS
                          <span v-if="sortBy === 'stts_status'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'stts_date' ? toSort('stts_date') : toDesc();" style=" width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Tanggal STTS
                          <span v-if="sortBy === 'stts_date'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" style=" width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          No. STTS
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" style=" width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Dokumen STTS TTE
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'stts_signed_date' ? toSort('stts_signed_date') : toDesc();" style=" width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Tanggal TTE STTS
                          <span v-if="sortBy === 'stts_signed_date'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        
                      </tr>
                      <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                        <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 2px; text-align: center;" :style="getCellStyle(item)">
                          <!-- <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                
                                v-bind="attrs"
                                v-on="on"

                                min-width="25"
                                height="25"
                                x-small
                                @click="dialog.form = true; detailTab = 'pelanggan'; reset(index);"
                                rounded
                                color="blue"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-square-edit-outline</v-icon>
                              </v-btn>
                            </template>

                            <span>Ubah</span>
                          </v-tooltip>

                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="toDelete(item.id)"

                                v-bind="attrs"
                                v-on="on"

                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="red"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </template>
                            
                            <span>Hapus</span>
                          </v-tooltip> -->
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                
                                v-bind="attrs"
                                v-on="on"
                                @click="dialog.form = true; detailTab = 'pelanggan'; selected.detail = [{ ...item }]; fetchDetailOrder(item.id); process.create_qr = false; qr_code = '';"

                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="green"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-information-outline</v-icon>
                              </v-btn>
                            </template>

                            <span>Detail</span>
                          </v-tooltip>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.input_datetime | dateFull }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <div v-if="item.status === 'dalam proses'">
                            {{ getSisaHari(item.expired_verifikasi_date) }} Hari
                          </div>
                          <div v-else>
                            -
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <div v-if="item.status === 'diterima' && item.payment_status === 'belum lunas'">
                            {{ item.days }} hari {{ item.hours }} jam {{ item.minutes }} menit {{ item.seconds }} detik
                          </div>
                          <div v-else>
                            -
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <div v-if="item.event_start_date === item.event_end_date">
                            {{ item.event_start_date | dateFull }}
                          </div>
                          <div v-else>
                            {{ item.event_start_date | dateFull }} - {{ item.event_end_date | dateFull }}
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.product_name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.event_name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.so_event_name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.customer_name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.customer_mobilephone }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.customer_email }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.id_billing || '-' }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.total | price }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)" class="text-capitalize">{{ item.status }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 100%; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)" class="text-capitalize">{{ item.payment_status }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <span v-if="item.payment_datetime && item.payment_datetime !== ''" class="black--text">
                            {{ item.payment_datetime | dateTimeFull }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)" class="text-capitalize">
                          {{ item.sts_status || '-' }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <span v-if="item.sts_date">{{ item.sts_date | dateFull }}</span>
                          <span v-else>-</span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          {{ item.sts_number || '-' }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <a
                            v-if="item.sts_signed_url"
                            href="javascript:;"
                            class="order-detail__link"
                            @click.stop.prevent="openPdfPreview(item.sts_signed_url, 'Dokumen STS TTE')">
                            Lihat
                            <v-icon size="12" class="ml-1">mdi-file-pdf-box</v-icon>
                          </a>
                          <span v-else>-</span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <span v-if="item.sts_signed_date">{{ item.sts_signed_date | dateFull }}</span>
                          <span v-else>-</span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)" class="text-capitalize">
                          {{ item.stts_status || '-' }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <span v-if="item.stts_date">{{ item.stts_date | dateFull }}</span>
                          <span v-else>-</span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          {{ item.stts_number || '-' }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <a
                            v-if="item.stts_signed_url"
                            href="javascript:;"
                            class="order-detail__link"
                            @click.stop.prevent="openPdfPreview(item.stts_signed_url, 'Dokumen STTS TTE')">
                            Lihat
                            <v-icon size="12" class="ml-1">mdi-file-pdf-box</v-icon>
                          </a>
                          <span v-else>-</span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <span v-if="item.stts_signed_date">{{ item.stts_signed_date | dateFull }}</span>
                          <span v-else>-</span>
                        </td>
                        
                      </tr>
                    </table>
                  </div>
    
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
    
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
    
                  <v-card-text
                    v-if="!process.load && list.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>
    
                  <pagination v-if="!process.load && pagination.total_data > 0"
                    @changePage="fetch($event)" 
                    @reloadPage="fetch($event)" 
                    :model="pagination" :display="paginationList"/>
    
                </div>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import { pdfUploadUrl, getCdnStoredPath } from "@/utils/cdn"
  import { resolveKadisEsignCoordsFromPdf } from "@/utils/esignCoordsFromPdf"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false,
          approval: false,
          update: false,
          upgrade: false,
          esign: false,
          esignResult: false,
          pdfPreview: false,
        },

        detailTab: 'pelanggan',

        esign: {
          type: '',
          passphrase: '',
          result: '',
          resultMessage: ''
        },

        pdfPreview: {
          title: '',
          url: '',
          filename: ''
        },

        // BSrE: width/height = sudut kiri-bawah (bukan ukuran).
        // xAxis/yAxis = sudut kanan-atas. Origin kiri-bawah PDF.
        // Ukuran QR = min(xAxis-width, yAxis-height).
        // Fallback saja — posisi dinamis dari teks "KEPALA DINAS PERUMAHAN".
        esignCoords: {
          sts:  { page: 1, xAxis: 466, yAxis: 224, width: 416, height: 174 },
          stts: { page: 1, xAxis: 466, yAxis: 210, width: 416, height: 160 }
        },

        menu: {
          input_datetime_gte: false,
          input_datetime_lte: false,
          event_start_date: false,
          event_end_date: false,
          payment_datetime_gte: false,
          payment_datetime_lte: false,
        },
        
        search: '',

        dateFilterType: 'input', // default: Tanggal Input. 'input' | 'booking' | 'payment' - hanya satu yang aktif

        filter: {
          date: '',
          product_id: '',
          status: 'dalam proses',
          status_payment: '',
          sts_status: '',
          stts_status: '',
          // Date range filters
          input_datetime_gte: '',
          input_datetime_lte: '',
          event_start_date: '',
          event_end_date: '',
          payment_datetime_gte: '',
          payment_datetime_lte: '',
          // Text filters
          customer_name: '',
          customer_mobilephone: '',
          customer_email: '',
          event_name: '',
          // Number filters
          total: ''
        },

        appliedFilter: {
          date: '',
          product_id: '',
          status: 'dalam proses',
          status_payment: '',
          sts_status: '',
          stts_status: '',
          // Date range filters
          input_datetime_gte: '',
          input_datetime_lte: '',
          event_start_date: '',
          event_end_date: '',
          payment_datetime_gte: '',
          payment_datetime_lte: '',
          // Text filters
          customer_name: '',
          customer_mobilephone: '',
          customer_email: '',
          event_name: '',
          // Number filters
          total: ''
        },

        upload: {
          folder: null
        },
        

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          detail: [],
          approval: [],
          upgrade_from_detail: null
        },

        paginationList: {
          row: 20,
          page: 1
        },

        role: [],
        sortBy: 'id',
        sortDesc: '-',

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          date: '',
          description: ''
        },

        product: [],
        status: [
          {
            text: 'Dalam Proses',
            value: 'dalam proses'
          },
          {
            text: 'Diterima',
            value: 'diterima'
          },
          {
            text: 'Ditolak',
            value: 'ditolak'
          },
          {
            text: 'Expired',
            value: 'expired'
          }
        ],

        esignStatusOptions: [
          {
            text: 'Belum',
            value: 'belum'
          },
          {
            text: 'Sudah',
            value: 'sudah'
          }
        ],

        qr_code: '',

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          export: false,
          form: false,
          file: false,
          approval: false,
          detail: false,
          export_excel: false,
          create_qr: false,
          export_stts: false,
          esign_sts: false,
          esign_stts: false,
          pdf_download: false,
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
      UpdatOrder: () => import(/* webpackPrefetch: true */ '@/components/order/update-order.vue'),
      UpgradeOrder: () => import(/* webpackPrefetch: true */ '@/components/order/upgrade-order.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }


      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.image_url = this.upload.folder.data.full.file_url
              this.form.image_url = this.upload.folder.fullpath
            }
          }
        },
        deep: true
      },

      'dialog.filter' (isOpen) {
        if (isOpen) {
          if (this.filter.input_datetime_gte || this.filter.input_datetime_lte) this.dateFilterType = 'input'
          else if (this.filter.event_start_date || this.filter.event_end_date) this.dateFilterType = 'booking'
          else if (this.filter.payment_datetime_gte || this.filter.payment_datetime_lte) this.dateFilterType = 'payment'
          else this.dateFilterType = 'input'
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      isBpkpad () {
        return (this.$store.state.user && this.$store.state.user.role === 'bpkpad') || false
      },
      isKadis () {
        return (this.$store.state.user && this.$store.state.user.role === 'kadis') || false
      },
      canManageOrder () {
        return !this.isBpkpad && !this.isKadis
      },
      esignProcessing () {
        return this.process.esign_sts || this.process.esign_stts
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      activeFilters () {
        const filters = []
        
        // Date range filters
        if (this.appliedFilter.input_datetime_gte || this.appliedFilter.input_datetime_lte) {
          const start = this.appliedFilter.input_datetime_gte ? moment(this.appliedFilter.input_datetime_gte).format('dddd, DD MMMM YYYY') : '...'
          const end = this.appliedFilter.input_datetime_lte ? moment(this.appliedFilter.input_datetime_lte).format('dddd, DD MMMM YYYY') : '...'
          filters.push({
            key: 'input_datetime',
            label: 'Tanggal Input',
            value: `${start} - ${end}`
          })
        }
        if (this.appliedFilter.event_start_date || this.appliedFilter.event_end_date) {
          const start = this.appliedFilter.event_start_date ? moment(this.appliedFilter.event_start_date).format('dddd, DD MMMM YYYY') : '...'
          const end = this.appliedFilter.event_end_date ? moment(this.appliedFilter.event_end_date).format('dddd, DD MMMM YYYY') : '...'
          filters.push({
            key: 'event_date',
            label: 'Tanggal Booking',
            value: `${start} - ${end}`
          })
        }
        if (this.appliedFilter.payment_datetime_gte || this.appliedFilter.payment_datetime_lte) {
          const start = this.appliedFilter.payment_datetime_gte ? moment(this.appliedFilter.payment_datetime_gte).format('dddd, DD MMMM YYYY') : '...'
          const end = this.appliedFilter.payment_datetime_lte ? moment(this.appliedFilter.payment_datetime_lte).format('dddd, DD MMMM YYYY') : '...'
          filters.push({
            key: 'payment_datetime',
            label: 'Tanggal Pembayaran',
            value: `${start} - ${end}`
          })
        }

        // Product filter
        if (this.appliedFilter.product_id) {
          const product = this.product.find(p => p.id === this.appliedFilter.product_id)
          filters.push({
            key: 'product_id',
            label: 'Fasilitas Umum',
            value: product ? product.name : this.appliedFilter.product_id
          })
        }

        // Status filter (kadis: selalu diterima, tidak ditampilkan sebagai chip yang bisa di-clear)
        if (!this.isKadis && this.appliedFilter.status && this.appliedFilter.status !== 'dalam proses') {
          const statusItem = this.status.find(s => s.value === this.appliedFilter.status)
          filters.push({
            key: 'status',
            label: 'Status',
            value: statusItem ? statusItem.text : this.appliedFilter.status
          })
        }

        // Status payment filter
        if (this.appliedFilter.status_payment) {
          const statusPaymentMap = {
            'lunas': 'Lunas',
            'belum_lunas': 'Belum Lunas'
          }
          filters.push({
            key: 'status_payment',
            label: 'Status Pembayaran',
            value: statusPaymentMap[this.appliedFilter.status_payment] || this.appliedFilter.status_payment
          })
        }

        if (this.appliedFilter.sts_status) {
          const stsItem = this.esignStatusOptions.find(s => s.value === this.appliedFilter.sts_status)
          filters.push({
            key: 'sts_status',
            label: 'Status STS',
            value: stsItem ? stsItem.text : this.appliedFilter.sts_status
          })
        }

        if (this.appliedFilter.stts_status) {
          const sttsItem = this.esignStatusOptions.find(s => s.value === this.appliedFilter.stts_status)
          filters.push({
            key: 'stts_status',
            label: 'Status STTS',
            value: sttsItem ? sttsItem.text : this.appliedFilter.stts_status
          })
        }

        // Text filters
        if (this.appliedFilter.customer_name) {
          filters.push({
            key: 'customer_name',
            label: 'Nama Pelanggan',
            value: this.appliedFilter.customer_name
          })
        }
        if (this.appliedFilter.customer_mobilephone) {
          filters.push({
            key: 'customer_mobilephone',
            label: 'Telepon Pelanggan',
            value: this.appliedFilter.customer_mobilephone
          })
        }
        if (this.appliedFilter.customer_email) {
          filters.push({
            key: 'customer_email',
            label: 'Email Pelanggan',
            value: this.appliedFilter.customer_email
          })
        }
        if (this.appliedFilter.event_name) {
          filters.push({
            key: 'event_name',
            label: 'Nama Event',
            value: this.appliedFilter.event_name
          })
        }

        // Number filters
        if (this.appliedFilter.total) {
          filters.push({
            key: 'total',
            label: 'Total Pembayaran',
            value: this.appliedFilter.total
          })
        }

        return filters
      },
      activeFiltersCount () {
        return this.activeFilters.length
      },
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
    mounted () {
      if (this.isKadis) {
        this.filter.status = 'diterima'
        this.appliedFilter.status = 'diterima'
      } else {
        this.appliedFilter = Object.assign({}, this.filter)
      }
      this.fetch()
      this.fetchProduct()
    },
    methods: {
      getCellStyle(item) {
        // Jika payment_status lunas, berikan background hijau
        if (item.payment_status === 'lunas') {
          return 'background-color: #c8e6c9'; // hijau muda
        }

        // Jika diterima, belum lunas, dan waktu tersisa < 6 jam
        const totalHoursLeft = item.days * 24 + item.hours;
        const isWarning = item.status === 'diterima' &&
                          item.payment_status === 'belum lunas' &&
                          totalHoursLeft < 6;

        if (isWarning) {
          return 'background-color: #ffb3b3'; // merah muda
        }

        // Default: jika status 'dalam proses' dan sisa hari = 1
        if (this.getSisaHari(item.expired_verifikasi_date) === '1' &&
            item.status === 'dalam proses') {
          return 'background-color: #ffdede';
        }

        return 'background-color: white';
      },

      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },

      getSisaHari(date) {
        // if (!date || !moment(date).isValid()) return '0';
        
        // const now = moment();
        // const target = moment(date);

        // const diff = target.diff(now, 'days');

        if (!date || !moment(date).isValid()) return '0';

        const now = moment();
        const target = moment(date);

        const diffMs = target.diff(now);
        const diff = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        
        if (isNaN(diff)) return '0';
        return diff < 0 ? '0' : `${diff}`;
      },


      async fetchProduct () {
        let params = {
          limit: 1000000
        }
        await get(`admin/product/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.product = res.results.data
          }
        })
      },

      async fetchDetail () {
        let params = {
          limit: 1000000
        }
        await get(`admin/product/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.product = res.results.data
          }
        })
      },

      async fetchDetailOrder (id) {
        this.process.detail = true
        this.selected.upgrade_from_detail = null
        const previousPaymentDatetime = this.selected.detail[0] && this.selected.detail[0].payment_datetime
        let params = {
          id: id
        }
        await get(`admin/order/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.detail = false

          if (res.status === 200) {
            let data = []
            res.results.data.so_detail.map(detail => {
              data.push({
                ...detail,
                price: detail.price_value
              })
            })
            this.$set(this.selected.detail, 0, {
              ...res.results.data,
              so_detail: data,
              payment_datetime: res.results.data.payment_datetime || previousPaymentDatetime || ''
            })

            this.fetchDetailOrderPayment(id)

            if (this.selected.detail[0].upgrade_from_so_id !== undefined && this.selected.detail[0].upgrade_from_so_id !== null && this.selected.detail[0].upgrade_from_so_id !== '' && this.selected.detail[0].upgrade_from_so_id !== '0' && this.selected.detail[0].upgrade_from_so_id !== 0) {
              this.fetchUpgradeFromOrder(this.selected.detail[0].upgrade_from_so_id)
            }

            if (this.selected.detail[0].id_billing !== '' && this.selected.detail[0].status === 'diterima' && this.selected.detail[0].payment_status === 'belum lunas') {
              this.CreateQr()
            }
          }
        })
      },

      async fetchDetailOrderPayment (id) {
        // this.process.detail = true
        let params = {
          so_id: id
        }
        await get(`admin/order/check_status`, { params })
        .then(response => {
          let res = response.data

          this.process.detail = false

          if (res.status === 200) {
            if (res.results.data.payment_status) {
              this.$set(this.selected.detail[0], 'payment_status', res.results.data.payment_status)
            }
            // Jangan timpa tanggal yang sudah ada dengan nilai kosong dari check_status
            if (res.results.data.payment_datetime) {
              this.$set(this.selected.detail[0], 'payment_datetime', res.results.data.payment_datetime)
            }
          }
        })
      },

      async fetchUpgradeFromOrder (id) {
        let params = {
          id: id
        }
        await get(`admin/order/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.selected.upgrade_from_detail = res.results.data
          }
        })
      },

      resetFilter () {
        this.dateFilterType = 'input'
        this.filter = {
          date: '',
          product_id: '',
          status: this.isKadis ? 'diterima' : 'dalam proses',
          status_payment: '',
          sts_status: '',
          stts_status: '',
          input_datetime_gte: '',
          input_datetime_lte: '',
          event_start_date: '',
          event_end_date: '',
          payment_datetime_gte: '',
          payment_datetime_lte: '',
          customer_name: '',
          customer_mobilephone: '',
          customer_email: '',
          event_name: '',
          total: ''
        }
        this.appliedFilter = Object.assign({}, this.filter)
      },

      onDateFilterTypeChange () {
        this.clearOtherDateFilterGroups(this.dateFilterType)
      },

      onStatusFilterChange () {
        if (this.isKadis) {
          this.filter.status = 'diterima'
          this.appliedFilter.status = 'diterima'
          return
        }
        this.appliedFilter.status = this.filter.status
        this.fetch()
      },

      clearStatusFilter () {
        if (this.isKadis) {
          this.filter.status = 'diterima'
          this.appliedFilter.status = 'diterima'
          return
        }
        this.filter.status = ''
        this.appliedFilter.status = ''
        this.fetch()
      },

      applyFilter () {
        if (this.isKadis) {
          this.filter.status = 'diterima'
        }
        // Copy filter to appliedFilter
        this.appliedFilter = Object.assign({}, this.filter)
        this.dialog.filter = false
        this.dialog.fullscreen = false
        this.fetch()
      },

      clearOtherDateFilterGroups (activeGroup) {
        if (activeGroup !== 'input') {
          this.filter.input_datetime_gte = ''
          this.filter.input_datetime_lte = ''
        }
        if (activeGroup !== 'booking') {
          this.filter.event_start_date = ''
          this.filter.event_end_date = ''
        }
        if (activeGroup !== 'payment') {
          this.filter.payment_datetime_gte = ''
          this.filter.payment_datetime_lte = ''
        }
      },

      clearFilter (key) {
        switch (key) {
          case 'input_datetime':
            this.dateFilterType = 'input'
            this.filter.input_datetime_gte = ''
            this.filter.input_datetime_lte = ''
            this.appliedFilter.input_datetime_gte = ''
            this.appliedFilter.input_datetime_lte = ''
            break
          case 'event_date':
            this.dateFilterType = 'input'
            this.filter.event_start_date = ''
            this.filter.event_end_date = ''
            this.appliedFilter.event_start_date = ''
            this.appliedFilter.event_end_date = ''
            break
          case 'payment_datetime':
            this.dateFilterType = 'input'
            this.filter.payment_datetime_gte = ''
            this.filter.payment_datetime_lte = ''
            this.appliedFilter.payment_datetime_gte = ''
            this.appliedFilter.payment_datetime_lte = ''
            break
          case 'product_id':
            this.filter.product_id = ''
            this.appliedFilter.product_id = ''
            break
          case 'status':
            if (this.isKadis) {
              this.filter.status = 'diterima'
              this.appliedFilter.status = 'diterima'
            } else {
              this.filter.status = 'dalam proses'
              this.appliedFilter.status = 'dalam proses'
            }
            break
          case 'status_payment':
            this.filter.status_payment = ''
            this.appliedFilter.status_payment = ''
            break
          case 'sts_status':
            this.filter.sts_status = ''
            this.appliedFilter.sts_status = ''
            break
          case 'stts_status':
            this.filter.stts_status = ''
            this.appliedFilter.stts_status = ''
            break
          case 'customer_name':
            this.filter.customer_name = ''
            this.appliedFilter.customer_name = ''
            break
          case 'customer_mobilephone':
            this.filter.customer_mobilephone = ''
            this.appliedFilter.customer_mobilephone = ''
            break
          case 'customer_email':
            this.filter.customer_email = ''
            this.appliedFilter.customer_email = ''
            break
          case 'event_name':
            this.filter.event_name = ''
            this.appliedFilter.event_name = ''
            break
          case 'total':
            this.filter.total = ''
            this.appliedFilter.total = ''
            break
        }
        this.fetch()
      },

      clearAllFilters () {
        this.resetFilter()
        this.fetch()
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          status: this.isKadis ? 'diterima' : this.filter.status,
          product_id: this.filter.product_id,
          payment_status: this.filter.status_payment,
          sts_status: this.filter.sts_status,
          stts_status: this.filter.stts_status,
          search: this.search
        }

        // Jangan kirim filter yang kosong (tetap kirim 0 kalau itu nilai valid)
        params = Object.entries(params).reduce((acc, [key, value]) => {
          const isEmpty =
            value === null ||
            value === undefined ||
            (typeof value === 'string' && value.trim() === '') ||
            (Array.isArray(value) && value.length === 0)

          if (!isEmpty) acc[key] = value
          return acc
        }, {})

        // Date range filters (hanya yang dipilih di radio)
        let hasDateRange = false
        if (this.dateFilterType === 'input') {
          if (this.filter.input_datetime_gte) {
            params['input_start_date'] = this.filter.input_datetime_gte
            hasDateRange = true
          }
          if (this.filter.input_datetime_lte) {
            params['input_end_date'] = this.filter.input_datetime_lte
            hasDateRange = true
          }
        } else if (this.dateFilterType === 'booking') {
          if (this.filter.event_start_date) {
            params['event_start_date'] = this.filter.event_start_date
            hasDateRange = true
          }
          if (this.filter.event_end_date) {
            params['event_end_date'] = this.filter.event_end_date
            hasDateRange = true
          }
        } else if (this.dateFilterType === 'payment') {
          if (this.filter.payment_datetime_gte) {
            params['payment_start_date'] = this.filter.payment_datetime_gte
            hasDateRange = true
          }
          if (this.filter.payment_datetime_lte) {
            params['payment_end_date'] = this.filter.payment_datetime_lte
            hasDateRange = true
          }
        }
        params.is_filter_range = hasDateRange

        // Text filters
        if (this.filter.customer_name) {
          params['customer_name[lse]'] = this.filter.customer_name
        }
        if (this.filter.customer_mobilephone) {
          params['customer_mobilephone[lse]'] = this.filter.customer_mobilephone
        }
        if (this.filter.customer_email) {
          params['customer_email[lse]'] = this.filter.customer_email
        }
        if (this.filter.event_name) {
          params['event_name[lse]'] = this.filter.event_name
        }

        // Number filters
        if (this.filter.total) {
          params['total[eq]'] = this.filter.total
        }

        this.selected.row = []

        await get(`admin/order/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '150px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              // {
              //   text: 'Status',
              //   width: '100px',
              //   value: 'is_active',
              //   freeze: false,
              //   hide: false,
              //   align: 'center',
              //   format: 'bool'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama Lengkap',
                width: '300px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Kategori Pegawai',
                width: '200px',
                value: 'cat_title',
                freeze: false,
                hide: false
              },
              {
                text: 'Email',
                width: '200px',
                value: 'email',
                freeze: false,
                hide: false
              },
              {
                text: 'Telepon',
                width: '200px',
                value: 'mobilephone',
                freeze: false,
                hide: false
              },
              // {
              //   text: 'Jenis Kelamin',
              //   width: '200px',
              //   value: 'gender',
              //   freeze: false,
              //   hide: false
              // },
              // {
              //   text: 'Nama Outlet',
              //   width: '400px',
              //   value: 'outlet_name',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Dibuat Tanggal',
                width: '100%',
                value: 'input_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              }
            ]

            this.list = []
            this.pagination = res.results.pagination

            this.list = res.results.data.map(item => ({
              ...item,
              billing_expired_datetime: new Date(item.billing_expired_datetime),
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0,
            }));

            this.list.map(obj => {
              obj.is_active = obj.is_active === '1' ? true : false
            })

            this.updateCountdowns();
            this.intervalId = setInterval(this.updateCountdowns, 1000);


            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            // this.addFreezes()

            if (this.$refs['table-grid'] && this.$refs['table-grid'].$el) {
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
            }

            // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      updateCountdowns() {
        const now = new Date();

        this.list.forEach(item => {
          const diff = item.billing_expired_datetime - now;

          if (diff <= 0) {
            item.days = item.hours = item.minutes = item.seconds = 0;
            return;
          }

          const totalSeconds = Math.floor(diff / 1000);
          item.days = Math.floor(totalSeconds / (60 * 60 * 24));
          item.hours = Math.floor((totalSeconds % (60 * 60 * 24)) / 3600);
          item.minutes = Math.floor((totalSeconds % 3600) / 60);
          item.seconds = totalSeconds % 60;
        });
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          date: index !== undefined ? this.list[index].date : '',
          description: index !== undefined ? this.list[index].description : ''
        }

        this.process.form = false

        this.message.error = ''

        // if (this.dialog.form) 
      },

      async save () {
        if (!this.canManageOrder) {
          this.message.error = 'Anda tidak memiliki akses.'
          return
        }
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          // if (this.form.id === '') {
          //   this.list.push(
          //     {
          //       id: this.list.length,
          //       title: this.form.title,
          //       date: this.form.date,
          //       end_date: this.form.end_date,
          //       start_time: this.form.start_time,
          //       end_time: this.form.end_time,
          //       desc: this.form.desc,
          //       image_url: this.form.image_url
          //     }
          //   )
          // } else {
          //   this.list[this.form.id] = {
          //     id: this.form.id,
          //     title: this.form.title,
          //     date: this.form.date,
          //     end_date: this.form.end_date,
          //     start_time: this.form.start_time,
          //     end_time: this.form.end_time,
          //     desc: this.form.desc,
          //     image_url: this.form.image_url
          //   }
          // }
          // this.dialog.form = false

          // this.dialog.snackbar = true
          // this.message.success = this.form.id === '' ? 'Berhasil Menambah Agenda' : 'Berhasil Mengubah Agenda'

          // this.dialog.fullscreen = false

          // this.reset()

          // this.fetch()

          let url = this.form.id === '' ? 'admin/order/add' : 'admin/order/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            if (errors.length > 0 && this.$refs.form.refs[errors[0]['key']] && this.$refs.form.refs[errors[0]['key']].$el) {
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }
          }, 10)
        }
      },
      toDelete (id) {
        if (!this.canManageOrder) return
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        if (!this.canManageOrder) {
          this.message.error = 'Anda tidak memiliki akses.'
          return
        }
        this.message.error = ''

        this.process.delete = true

        await post(`admin/order/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },
      async approvals () {
        if (!this.canManageOrder) {
          this.message.error = 'Anda tidak memiliki akses.'
          return
        }
        this.message.error = ''

        this.process.approval = true

        await post(`admin/order/approval`, {
          data: {
            id: this.selected.detail[0].id,
            status: this.selected.approval[0].status,
            description: this.selected.approval[0].description
          }
        }).then(response => {
          let res = response.data

          this.process.approval = false

          if (res.status === 200) {

            this.dialog.approval = false
            this.dialog.form = false

            this.selected.row = []
            this.selected.approval = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      async CreateQr () {
        this.message.error = ''

        this.process.create_qr = true

        try {
          const response = await post(`sites/order/create_qr`, {
            data: {
              id_billing: `73${this.selected.detail[0].id_billing}`
            }
          })
          
          let res = response.data

          // console.log(res)

          if (res.status === 200) {

            // Fetch HTML dari URL QRIS
            const htmlResponse = await fetch(res.results.data.data)
            const htmlText = await htmlResponse.text()
            
            // console.log('HTML Response:', htmlText.substring(0, 500)) // Log first 500 chars
            
            // Parse HTML untuk mendapatkan gambar QRIS
            const parser = new DOMParser()
            const doc = parser.parseFromString(htmlText, 'text/html')
            const imgElement = doc.querySelector('#qrResults')

            // console.log('imgElement:', imgElement)
            // console.log('qrisUrl:', qrisUrl)
            
            if (imgElement && imgElement.src) {
              this.qr_code = imgElement.src
              // loadingQris.value = false
              // console.log('QRIS image URL:', qris.value)
            } else {
              console.error('QRIS image not found in HTML')
              // Coba cari elemen img lain
              const allImages = doc.querySelectorAll('img')
              // console.log('All images found:', allImages)
              // Jika tidak ada #qrResults, coba gunakan gambar pertama
              if (allImages.length > 0 && allImages[0].src) {
                this.qr_code = allImages[0].src
                // console.log('Using first image:', qris.value)
              }
            }

          this.process.create_qr = false

            // this.dialog.approval = false
            // this.dialog.form = false

            // this.selected.row = []
            // this.selected.approval = []
            
            // this.dialog.snackbar = true
            // this.message.success = res.message

            // this.dialog.fullscreen = false

            // this.fetch()
          } else {
            this.message.error = res.message
          }
        } catch (error) {
          this.process.create_qr = false
          this.message.error = error.message || 'Terjadi kesalahan saat membuat QR'
        }
      },
      // EXPORT
      async exports (id) {
        this.message.error = ''

        this.process.export = true

        let params = {
          id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/admin/order/export_pdf_sts`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response
          // console.log(res)

          this.process.export = false
          let disposition = res.headers['content-disposition']
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          let filename = ''
          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },

      async exportsStts (id) {
        this.message.error = ''

        this.process.export_stts = true

        let params = {
          id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/admin/order/export_pdf_stts`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response
          // console.log(res)

          this.process.export_stts = false
          let disposition = res.headers['content-disposition']
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          let filename = ''
          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf STTS'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },

      openEsignDialog (type) {
        this.message.error = ''
        this.esign.type = type
        this.esign.passphrase = ''
        this.esign.result = ''
        this.esign.resultMessage = ''
        this.dialog.esignResult = false
        this.dialog.esign = true
      },

      closeEsignDialog () {
        if (this.esignProcessing) return
        this.dialog.esign = false
        this.esign.passphrase = ''
        this.message.error = ''
      },

      closeEsignResultDialog () {
        this.dialog.esignResult = false
        this.esign.resultMessage = ''
      },

      openPdfPreview (url, title = 'Preview PDF') {
        if (!url) return

        const displayUrl = this.getCdnDisplayUrl(url)
        const pathPart = String(displayUrl).split('?')[0]
        const rawName = pathPart.split('/').pop() || 'dokumen.pdf'
        const filename = decodeURIComponent(rawName).endsWith('.pdf')
          ? decodeURIComponent(rawName)
          : `${decodeURIComponent(rawName)}.pdf`

        this.pdfPreview = {
          title,
          url: displayUrl,
          filename
        }
        this.dialog.pdfPreview = true
      },

      closePdfPreview () {
        this.dialog.pdfPreview = false
        this.pdfPreview = {
          title: '',
          url: '',
          filename: ''
        }
        this.process.pdf_download = false
      },

      openPdfPreviewInNewTab () {
        if (!this.pdfPreview.url) return
        window.open(this.pdfPreview.url, '_blank')
      },

      async downloadPdfPreview () {
        if (!this.pdfPreview.url || this.process.pdf_download) return

        this.process.pdf_download = true
        const filename = this.pdfPreview.filename || 'dokumen.pdf'

        try {
          const response = await fetch(this.pdfPreview.url)
          if (!response.ok) throw new Error('Gagal mengunduh PDF')

          const blob = await response.blob()
          const blobUrl = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = blobUrl
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(blobUrl)
        } catch (e) {
          // Fallback jika CDN block CORS: buka di tab baru
          window.open(this.pdfPreview.url, '_blank')
        } finally {
          this.process.pdf_download = false
        }
      },

      async fetchOrderPdfBlob (type, orderId) {
        const endpoint = type === 'stts' ? 'export_pdf_stts' : 'export_pdf_sts'

        const response = await axios({
          url: `${process.env.VUE_APP_API_URL}/admin/order/${endpoint}`,
          method: 'GET',
          responseType: 'blob',
          params: { id: orderId },
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        })

        if (response.status !== 200) {
          throw new Error('Gagal mengunduh PDF')
        }

        let filename = `${type}.pdf`
        const disposition = response.headers['content-disposition']
        if (disposition) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }
        }

        return {
          blob: response.data,
          filename
        }
      },

      downloadBase64Pdf (base64, filename) {
        const blob = this.base64ToPdfBlob(base64)
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        return blob
      },

      base64ToPdfBlob (base64) {
        const byteCharacters = atob(base64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        return new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' })
      },

      async uploadSignedPdfToCdn (blob, filename) {
        const formData = new FormData()
        formData.append('key', 'file')
        formData.append('file', blob, filename)
        formData.append('client_name', 'sifasum')
        formData.append('visibility', 'private')

        const response = await fetch(pdfUploadUrl, {
          method: 'POST',
          body: formData
        })

        if (!response.ok) {
          throw new Error('Gagal mengunggah PDF ke CDN.')
        }

        const uploaded = await response.json()
        const signedUrl = getCdnStoredPath(uploaded)

        if (!signedUrl) {
          throw new Error(uploaded.message || 'Respon CDN tidak berisi path file.')
        }

        return signedUrl
      },

      async saveSignedUrl ({ docType, soId, signedUrl }) {
        const response = await post(`admin/sign/signed_url`, {
          data: {
            doc_type: docType,
            so_id: soId,
            signed_url: signedUrl
          }
        })

        const res = response.data
        if (res.status !== 200) {
          throw new Error(res.message || 'Gagal menyimpan URL dokumen TTE.')
        }

        return res
      },

      async esignOrderPdf () {
        this.message.error = ''

        const passphrase = this.esign.passphrase || ''
        if (!passphrase) {
          this.message.error = 'Passphrase wajib diisi.'
          return
        }
        this.esign.passphrase = ''

        const type = this.esign.type
        const order = this.selected.detail[0]
        if (!order || !order.id) return

        const processKey = type === 'stts' ? 'esign_stts' : 'esign_sts'
        this.process[processKey] = true

        try {
          const { blob, filename } = await this.fetchOrderPdfBlob(type, order.id)
          let coords = this.esignCoords[type]
          const dynamicCoords = await resolveKadisEsignCoordsFromPdf(blob)
          if (dynamicCoords) {
            coords = dynamicCoords
          }
          const idBilling = order.id_billing
          const linkQR = `https://sifasum.klaten.go.id/verify`
          const signedFilename = `${type}-signed-${idBilling}.pdf`

          const form = new FormData()
          form.append('version', '1')
          form.append('passphrase', passphrase)
          form.append('tampilan', 'visible')
          form.append('image', 'false')
          form.append('linkQR', linkQR)
          form.append('page', String(coords.page))
          form.append('xAxis', String(coords.xAxis))
          form.append('yAxis', String(coords.yAxis))
          form.append('width', String(coords.width))
          form.append('height', String(coords.height))
          form.append('reason', 'TTE Dokumen')
          form.append('location', 'Klaten')
          form.append('doc_type', type)
          form.append('so_id', String(order.id))
          form.append('file', blob, filename)

          const response = await axios.post(
            `${process.env.VUE_APP_API_URL}/admin/sign/pdf`,
            form,
            {
              headers: {
                Authorization: process.env.VUE_APP_XAUTH,
                token: TokenService.getToken()
              }
            }
          )

          const res = response.data
          if (res.status === 200 && res.results && res.results.data && res.results.data.file_base64) {
            const signedBlob = this.base64ToPdfBlob(res.results.data.file_base64)
            const signedUrl = await this.uploadSignedPdfToCdn(signedBlob, signedFilename)
            await this.saveSignedUrl({
              docType: type,
              soId: order.id,
              signedUrl
            })

            this.esign.result = 'success'
            this.esign.resultMessage = res.message || `Berhasil menandatangani ${type.toUpperCase()}`
            this.dialog.esign = false
            this.esign.passphrase = ''
            this.dialog.esignResult = true
            this.fetch()
            this.fetchDetailOrder(order.id)
          } else {
            this.esign.result = 'error'
            this.esign.resultMessage = res.message || 'Gagal menandatangani dokumen.'
            this.dialog.esignResult = true
          }
        } catch (error) {
          let errMsg = 'Terjadi kesalahan saat proses TTE.'
          if (error.response && error.response.data) {
            if (typeof error.response.data === 'string') {
              try {
                const parsed = JSON.parse(error.response.data)
                errMsg = parsed.message || errMsg
              } catch (e) {
                errMsg = error.response.data
              }
            } else if (error.response.data.message) {
              errMsg = error.response.data.message
            }
          } else if (error.message) {
            errMsg = error.message
          }
          this.esign.result = 'error'
          this.esign.resultMessage = errMsg
          this.dialog.esignResult = true
        } finally {
          this.process[processKey] = false
          this.esign.passphrase = ''
        }
      },

      async exports_excel () {
        this.message.error = ''

        this.process.export_excel = true

        let params = {
          limit: 100000000000,
          // page: this.paginationList.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          status: this.filter.status,
          product_id: this.filter.product_id,
          payment_status: this.filter.status_payment,
          sts_status: this.filter.sts_status,
          stts_status: this.filter.stts_status,
          search: this.search
        }

        // Jangan kirim filter yang kosong (tetap kirim 0 kalau itu nilai valid)
        params = Object.entries(params).reduce((acc, [key, value]) => {
          const isEmpty =
            value === null ||
            value === undefined ||
            (typeof value === 'string' && value.trim() === '') ||
            (Array.isArray(value) && value.length === 0)

          if (!isEmpty) acc[key] = value
          return acc
        }, {})

        // Date range filters (hanya yang dipilih di radio)
        let hasDateRangeExcel = false
        if (this.dateFilterType === 'input') {
          if (this.filter.input_datetime_gte) {
            params.input_start_date = this.filter.input_datetime_gte
            hasDateRangeExcel = true
          }
          if (this.filter.input_datetime_lte) {
            params.input_end_date = this.filter.input_datetime_lte
            hasDateRangeExcel = true
          }
        } else if (this.dateFilterType === 'booking') {
          if (this.filter.event_start_date) {
            params.event_start_date = this.filter.event_start_date
            hasDateRangeExcel = true
          }
          if (this.filter.event_end_date) {
            params.event_end_date = this.filter.event_end_date
            hasDateRangeExcel = true
          }
        } else if (this.dateFilterType === 'payment') {
          if (this.filter.payment_datetime_gte) {
            params.payment_start_date = this.filter.payment_datetime_gte
            hasDateRangeExcel = true
          }
          if (this.filter.payment_datetime_lte) {
            params.payment_end_date = this.filter.payment_datetime_lte
            hasDateRangeExcel = true
          }
        }
        params.is_filter_range = hasDateRangeExcel

        // Text filters
        if (this.filter.customer_name) {
          params['customer_name[lse]'] = this.filter.customer_name
        }
        if (this.filter.customer_mobilephone) {
          params['customer_mobilephone[lse]'] = this.filter.customer_mobilephone
        }
        if (this.filter.customer_email) {
          params['customer_email[lse]'] = this.filter.customer_email
        }
        if (this.filter.event_name) {
          params['event_name[lse]'] = this.filter.event_name
        }

        // Number filters
        if (this.filter.total) {
          params['total[eq]'] = this.filter.total
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/order/data/export`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export_excel = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          // let filename = ''

          // if (disposition && disposition.indexOf('inline') !== -1) {
          //   var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          //   var matches = filenameRegex.exec(disposition);
          //   if (matches != null && matches[1]) { 
          //     filename = matches[1].replace(/['"]/g, '');
          //   }
          // }
          console.log(fileName)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  /* width: 100%; */
}

.wrapper-pegawai { 
  overflow-y: auto; 
  height: calc(100vh - 265px); 
} 

.wrapper-pegawai th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  /* background-color: #080679 !important; */
}

.one-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}

/* —— Detail Pemakaian / Penggunaan (mockup redesign) —— */
.order-detail-dialog-wrap {
  overflow: hidden;
  border-radius: 14px !important;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25) !important;
}

.order-detail-dialog-wrap.v-dialog--fullscreen {
  border-radius: 0 !important;
}

.order-detail-dialog {
  background: #ffffff !important;
  color: #1B2027;
  display: flex;
  flex-direction: column;
  max-height: 92vh;
}

.order-detail-dialog.border-radius {
  border-radius: 14px !important;
}

.order-detail-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 28px 16px !important;
  background: #ffffff;
  border-bottom: 1px solid #E2E5E8;
}

.order-detail-dialog__header-text {
  min-width: 0;
}

.order-detail-dialog__eyebrow {
  margin: 0 0 4px;
  font-size: 13px;
  letter-spacing: 0.2px;
  color: #8A929C;
  font-weight: 400;
  line-height: 1.2;
  text-transform: none;
}

.order-detail-dialog__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #1B2027;
  line-height: 1.25;
}

.order-detail-dialog__head-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.order-detail-dialog__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid #E2E5E8;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  color: #5B6470;
  transition: background-color 0.15s ease;
}

.order-detail-dialog__icon-btn:hover {
  background: #F6F7F8;
}

.order-detail-dialog__body {
  padding: 20px 28px 8px !important;
  background: #ffffff;
}

.order-detail-dialog__footer {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 16px 28px !important;
  background: #ffffff;
  border-top: 1px solid #E2E5E8;
  gap: 10px;
}

.order-detail-dialog__foot-left {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.order-detail__summary {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
  padding: 18px 20px;
  margin-bottom: 20px;
  background: #F6F7F8;
  border: 1px solid #E2E5E8;
  border-radius: 10px;
}

.order-detail__facility {
  margin: 0 0 4px;
  font-size: 19px;
  font-weight: 700;
  color: #1B2027;
  line-height: 1.3;
}

.order-detail__summary-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.order-detail__booking {
  font-size: 14px;
  color: #5B6470;
  font-variant-numeric: tabular-nums;
}

.order-detail__booking-sep {
  margin: 0 4px;
  color: #8A929C;
}

.order-detail__badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  text-transform: capitalize;
  background: #F0F1F3;
  color: #3C4450;
  border: 0;
}

.order-detail__badge-icon {
  margin: 0 !important;
}

.order-detail__badge--dalam-proses {
  background: #E6F1F8;
  color: #0072B2;
}

.order-detail__badge--diterima {
  background: #E6F1F8;
  color: #0072B2;
}

.order-detail__badge--ditolak,
.order-detail__badge--expired {
  background: #f6ebe9;
  color: #7a3530;
}

.order-detail__badge--pay-lunas {
  background: #E4F5EF;
  color: #009E73;
}

.order-detail__badge--pay-belum-lunas {
  background: #FCF1DC;
  color: #8a6600;
}

.order-detail__summary-right {
  text-align: right;
  min-width: 140px;
}

.order-detail__total-label {
  font-size: 12px;
  letter-spacing: 0.4px;
  color: #8A929C;
  margin-bottom: 2px;
}

.order-detail__total-value {
  font-size: 26px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #1B2027;
  line-height: 1.15;
}

.order-detail__billing {
  margin-top: 4px;
  font-size: 13px;
  color: #8A929C;
  font-variant-numeric: tabular-nums;
}

.order-detail__tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #E2E5E8;
  margin-bottom: 15px;
}

.order-detail__tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 4px;
  margin-right: 24px;
  margin-bottom: -1px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  font-size: 14.5px;
  font-weight: 600;
  color: #8A929C;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.order-detail__tab-icon {
  color: inherit !important;
}

.order-detail__tab--active {
  color: #1B2027;
  border-bottom-color: #0072B2;
}

.order-detail__panel-tab {
  padding-bottom: 12px;
}

.order-detail__grid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
}

.order-detail__grid2--pay {
  margin-bottom: 22px;
}

.order-detail__field-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 4px;
}

.order-detail__field-icon {
  color: #8A929C !important;
  margin-top: 6px;
  flex-shrink: 0;
}

.order-detail__field-body {
  flex: 1;
  min-width: 0;
}

.order-detail__field-label {
  font-size: 12.5px;
  color: #8A929C;
  margin-bottom: 3px;
}

.order-detail__field-value {
  font-size: 15px;
  color: #1B2027;
  margin-bottom: 8px;
  line-height: 1.45;
  word-break: break-word;
}

.order-detail__mono {
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
}

.order-detail__link-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14.5px;
  color: #0072B2;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 16px;
  cursor: pointer;
}

.order-detail__link-row:hover {
  text-decoration: underline;
}

.order-detail__link-row--sm {
  font-size: 13px;
  margin-bottom: 0;
  margin-top: 4px;
}

.order-detail__section-label {
  font-size: 12.5px;
  color: #8A929C;
  margin-bottom: 10px;
  font-weight: 500;
}

.order-detail__section {
  margin-top: 22px;
}

.order-detail__docs {
  margin-bottom: 8px;
}

.order-detail__doc-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 14px 16px;
  margin-bottom: 12px;
  border: 1px solid #E2E5E8;
  border-radius: 10px;
  background: #ffffff;
}

.order-detail__doc-info {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
  flex: 1;
}

.order-detail__doc-name {
  font-size: 14.5px;
  font-weight: 600;
  color: #1B2027;
}

.order-detail__doc-sub {
  font-size: 12.5px;
  color: #8A929C;
}

.order-detail__doc-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #5B6470;
  line-height: 1.45;
}

.order-detail__doc-sep {
  margin: 0 4px;
  color: #C0C5CB;
}

.order-detail__doc-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.order-detail__btn {
  border-radius: 7px !important;
  min-width: 0 !important;
  height: 34px !important;
  padding: 0 14px !important;
  letter-spacing: 0 !important;
  box-shadow: none !important;
}

.order-detail__btn--download {
  background: #E6F1F8 !important;
  color: #0072B2 !important;
}

.order-detail__btn--download:hover {
  background: #d6e9f5 !important;
}

.order-detail__btn--sign {
  background: #E4F5EF !important;
  color: #009E73 !important;
}

.order-detail__btn--sign:hover {
  background: #d2eee2 !important;
}

.order-detail__qr {
  margin-top: 16px;
  margin-bottom: 12px;
}

.order-detail__qr-card {
  max-width: 360px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #E2E5E8;
  border-radius: 10px;
}

.order-detail__qr-banner img {
  display: block;
  width: 100%;
  max-height: 110px;
  object-fit: cover;
}

.order-detail__qr-code {
  padding: 20px 16px 8px;
  text-align: center;
}

.order-detail__qr-code img {
  max-width: 190px;
  height: auto;
}

.order-detail__qr-info {
  padding: 4px 16px 16px;
  text-align: center;
}

.order-detail__qr-name {
  font-size: 13px;
  font-weight: 600;
  color: #1B2027;
}

.order-detail__qr-amount {
  margin-top: 4px;
  font-size: 18px;
  font-weight: 700;
  color: #009E73;
  font-variant-numeric: tabular-nums;
}

.order-detail__qr-download {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  color: #fff !important;
  font-weight: 600;
  font-size: 13px;
  transition: filter 0.15s ease;
}

.order-detail__qr-download:hover {
  filter: brightness(0.96);
}

.order-detail__qr-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  max-width: 360px;
  margin-bottom: 12px;
  border: 1px dashed #E2E5E8;
  border-radius: 10px;
  color: #5B6470;
  font-size: 13px;
  background: #F6F7F8;
}

.order-detail__upgrade {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: 14px 16px;
  margin-top: 12px;
  margin-bottom: 12px;
  border-radius: 10px;
  background: #FCF1DC;
  border: 1px solid #f0dfa8;
}

.order-detail__upgrade-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #8a6600;
}

.order-detail__upgrade-meta {
  margin-top: 4px;
  font-size: 12.5px;
  color: #8a6600;
}

.order-detail__nominal {
  padding-top: 8px;
  border-top: 1px solid #E2E5E8;
}

.order-detail__nominal-row {
  padding: 2px 0;
}

.order-detail__nominal-row--divided {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #E2E5E8;
}

.order-detail__nominal-date,
.order-detail__nominal-price {
  font-size: 13px;
  font-weight: 600;
  color: #1B2027;
  font-variant-numeric: tabular-nums;
}

.order-detail__fasilitas {
  margin-top: 8px;
  padding-left: 10px;
  border-left: 2px solid #E2E5E8;
}

.order-detail__fasilitas-item + .order-detail__fasilitas-item {
  margin-top: 6px;
}

.order-detail__fasilitas-name,
.order-detail__fasilitas-price {
  font-size: 12px;
  color: #5B6470;
  font-variant-numeric: tabular-nums;
}

.order-detail__fasilitas-qty {
  margin-left: 4px;
  color: #8A929C;
}

.order-detail__nominal-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #E2E5E8;
  font-size: 14px;
  font-weight: 700;
  color: #1B2027;
  font-variant-numeric: tabular-nums;
}

.order-detail__attachments {
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
  gap: 16px;
  margin-top: 22px;
  margin-bottom: 8px;
}

.order-detail__attach {
  min-width: 0;
}

.order-detail__media {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #E2E5E8;
  border-radius: 10px;
}

.order-detail__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  padding: 24px;
}

.order-detail__loading-inner {
  width: 100%;
  max-width: 280px;
  text-align: center;
}

.order-detail__loading-title {
  font-size: 16px;
  font-weight: 700;
  color: #1B2027;
}

.order-detail__loading-sub {
  margin-top: 4px;
  font-size: 12.5px;
  color: #8A929C;
}

.esign-result {
  position: relative;
  padding-top: 8px;
}

.esign-result__close {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}

.esign-result__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 32px 8px !important;
}

.esign-result__icon-wrap {
  border-radius: 50%;
}

.esign-result__icon-wrap--success {
  background: #E4F5EF;
}

.esign-result__icon-wrap--error {
  background: #fbeceb;
}

.esign-result__title {
  margin-top: 18px;
  font-size: 22px;
  font-weight: 700;
  color: #1B2027;
}

.esign-result__message {
  margin-top: 8px;
  font-size: 14px;
  color: #8A929C;
  line-height: 1.5;
}

.esign-result__actions {
  display: flex;
  justify-content: center;
  padding: 20px 24px 28px !important;
}

.order-detail__footer-btn {
  border-radius: 7px !important;
  min-width: 108px;
  height: 40px !important;
  margin: 0 !important;
  padding: 0 18px !important;
  font-size: 14px !important;
  box-shadow: none !important;
}

.order-detail__footer-btn--primary {
  background: #0072B2 !important;
  color: #ffffff !important;
}

.order-detail__footer-btn--primary:hover {
  filter: brightness(1.08);
}

.order-detail__footer-btn--upgrade {
  background: #FCF1DC !important;
  color: #8a6600 !important;
}

.order-detail__footer-btn--upgrade:hover {
  background: #f8e6bd !important;
}

.order-detail__footer-btn--accept {
  background: #E4F5EF !important;
  color: #009E73 !important;
}

.order-detail__footer-btn--reject {
  background: #f6ebe9 !important;
  color: #7a3530 !important;
}

.order-detail__footer-btn--close {
  background: #F0F1F3 !important;
  color: #3C4450 !important;
}

.order-detail__footer-btn--close:hover {
  background: #e4e6e9 !important;
}

.pdf-preview__body {
  background: #f3f4f6;
  height: calc(100vh - 220px);
  max-height: 720px;
  min-height: 420px;
}

.pdf-preview__frame {
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}

@media (max-width: 960px) {
  .order-detail-dialog__header,
  .order-detail-dialog__body,
  .order-detail-dialog__footer {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .order-detail__summary-right {
    text-align: left;
    width: 100%;
    padding-top: 8px;
    border-top: 1px dashed #E2E5E8;
  }

  .order-detail__grid2,
  .order-detail__attachments {
    grid-template-columns: 1fr;
  }

  .order-detail__doc-group {
    align-items: flex-start;
  }

  .order-detail__tabs {
    overflow-x: auto;
  }

  .order-detail__tab {
    margin-right: 16px;
    white-space: nowrap;
  }
}
</style>